// @flow

import React, { Component } from 'react';

type State = {
  dropdownOpened: boolean
};

type Props = {
  equipe: string,
  withoutDropdown?: boolean
};

export default class OpponentTeamComposition extends Component<Props, State> {
  state: State = {
    dropdownOpened: false
  };

  handleClickDropDown: () => void = () => {
    this.setState(prevState => ({
      dropdownOpened: !prevState.dropdownOpened
    }));
  };

  componentDidMount() {
    const { withoutDropdown } = this.props;

    if (withoutDropdown) {
      this.setState({ dropdownOpened: true });
    }
  }

  render(): React$Element<'div'> {
    const { dropdownOpened } = this.state;
    const { equipe, withoutDropdown } = this.props;

    return (
      <div className="col col-lg-8on9">
        <div className="composition composition--ext customDropdown mt-4">
          <div className="js-customDropdown-content row" style={{ display: dropdownOpened ? 'block' : 'none' }}>
            <div className="col">
              <h3 className="mb-3">{"Composition de l'équipe adverse"}</h3>
            </div>
            <div className="composition__team col">
              <div className="team__body">
                <p>{equipe}</p>
              </div>
            </div>
          </div>
        </div>

        {!withoutDropdown && (
          <div
            className={
              dropdownOpened
                ? 'box box--white ft-center mt-5 js-customDropdown-buttonClose'
                : 'box box--white ft-center js-customDropdown-buttonOpen'
            }
          >
            <a
              className="link-chevron link-chevron--pagination link-chevron link-chevron--inline"
              role="button"
              tabIndex={0}
              onClick={() => this.handleClickDropDown()}
            >
              {!dropdownOpened ? (
                <span>{"Voir la composition de l'équipe adverse"}</span>
              ) : (
                <span>{"Fermer la composition de l'équipe adverse"}</span>
              )}
            </a>
          </div>
        )}
      </div>
    );
  }
}
